import { buildAppPath, isAppLocale, pathWithLocale, type AppLocale } from '@redevicer/shared'

/** Public listing URL for the current UI language. Crawlers read the href; the app still opens the detail in place. */
export function listingPublicPath(listingId: number, language: string): string {
  const code = (language || 'lt').toLowerCase().split('-')[0]
  const locale: AppLocale = isAppLocale(code) ? code : 'lt'
  return pathWithLocale(locale, buildAppPath({ page: 'buy', listingId }))
}
